import { Component, Inject, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderService } from 'src/app/order.service';
import { LinkedGiftCard } from 'src/app/models/gift-card';

@Component({
  selector: 'app-unlink-gift-card-dialog',
  templateUrl: './unlink-gift-card-dialog.component.html',
  styleUrls: ['./unlink-gift-card-dialog.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnlinkGiftCardDialogComponent implements OnInit {
  card: LinkedGiftCard;
  storeId: string;

  otp: string = '';
  otpSent: boolean = false;
  isLoading: boolean = false;
  errorMessage: string = '';

  constructor(
    private dialogRef: MatDialogRef<UnlinkGiftCardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private orderService: OrderService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.card = this.data.card;
    this.storeId = this.data.storeId;
    this.sendOTP();
  }

  sendOTP() {
    this.isLoading = true;
    this.errorMessage = '';

    this.orderService.requestUnlinkOTP(
      this.card.id,
      this.card.linked_phone,
      this.storeId
    ).subscribe(
      (response) => {
        this.otpSent = true;
        this.isLoading = false;
        this.cdr.markForCheck();
      },
      (error) => {
        this.isLoading = false;
        this.errorMessage = error.error?.detail || 'Failed to send OTP. Please try again.';
        this.cdr.markForCheck();
      }
    );
  }

  confirmUnlink() {
    if (!this.otp || this.otp.length !== 6) {
      this.errorMessage = 'Please enter a valid 6-digit OTP';
      this.cdr.markForCheck();
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    this.orderService.confirmUnlinkGiftCard(
      this.card.id,
      this.card.linked_phone,
      this.otp
    ).subscribe(
      (response) => {
        this.isLoading = false;
        this.cdr.markForCheck();
        this.dialogRef.close(true);
      },
      (error) => {
        this.isLoading = false;
        this.errorMessage = error.error?.detail || 'Invalid OTP. Please try again.';
        this.cdr.markForCheck();
      }
    );
  }

  getMaskedCardNumber(): string {
    if (this.card?.card_number && this.card.card_number.length >= 4) {
      return '****' + this.card.card_number.slice(-4);
    }
    return this.card?.card_number || '';
  }

  getMaskedPhoneNumber(): string {
    if (this.card?.linked_phone) {
      const phone = this.card.linked_phone;
      return '***-***-' + phone.slice(-4);
    }
    return '';
  }

  dismiss() {
    this.dialogRef.close(false);
  }
}
